import { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Container, Row, Col, Image } from "react-bootstrap";
import QuickApplyBolt from "src/imagesV2/bolt.svg";
import QuickApplyBoltWhite from "src/imagesV2/boltWhite.svg";
import { HOMEPAGE, QUICK_APPLY_ELIGIBLE } from "src/constants/campaigns_constants";
import { RecommendedJobsSourceTypes } from "src/types/receommendedJobsSource";
import PropTypes from "prop-types"
import { useTranslation, withTranslation } from "react-i18next";
import JobCardContainer from "../../JobResults/JobCardContainer";
import JobsCarousel from "../../JobDescription/JobsCarousel";
import JobViewsSkeleton from "./JobViewsSkeleton";

interface RootState {
  onBoarding: {
    specialtiesAndEducation: any;
    completedSections: any;
  };
}

const JobEligibilityDashboardAdvertisement = ({ isMobile, quickApplyAdvJobs, quickApplyAdvCarouselItems, isJobSearchWithViewsLoading, isInitApiLoading

}) => {
  const { t } = useTranslation();
  const [showSection, setShowSection] = useState(false)
  const completedSections = useSelector((state: RootState) => state.onBoarding.completedSections);
  const isProfileDataLoaded = completedSections &&   Object.keys(completedSections).filter(key => completedSections[`${[key]}`] === true);
  const isProfileIncomplete = isProfileDataLoaded && isProfileDataLoaded?.length < 5;

  useEffect(() => {
    if (!isProfileIncomplete && isJobSearchWithViewsLoading) setShowSection(true);
    if (!isJobSearchWithViewsLoading && !isInitApiLoading) {
      if ( quickApplyAdvJobs?.length === 0 || (completedSections && isProfileDataLoaded?.length === 0)) {
        setShowSection(false);
      } else {
        const allHaveZeroQuickApplyPercentage = quickApplyAdvJobs.every((job) => job.quickApplyPercentage === 0);
        if (allHaveZeroQuickApplyPercentage || isProfileIncomplete === null || isProfileIncomplete) {
          setShowSection(false);
        } else {
          setShowSection(true);
        }
      }
    }

  }, [isJobSearchWithViewsLoading, isInitApiLoading, completedSections, quickApplyAdvJobs])
  
  return (
    showSection ? (<Container fluid className="quickApplyAdContainer">
      <Container >
        <Row className="quickApplyTitleContainer">
          <h3 className="quickApplyAdHeading">
            <span>
              <Image className="quickApplyIcon" src={QuickApplyBolt} />
            </span>
            {t("dashboard.jobEligibility.quickApplyELigible")}
          </h3>
        </Row>
        <Row className="quickApplyCardsRow">
          <Col lg={3} xs={12} className="quickApplyDescColumn d-flex justify-content-center justify-content-sm-start">
            <Container className="quickApplyDescriptionContainer text-center text-sm-left">
              <Row className="quickApplyDescInnerContainer">
                <h4 className="quickApplyDescHeader">{t("dashboard.jobEligibility.heading")}</h4>
                <div className="quickApplyDescText hideText">
                  {t("dashboard.jobEligibility.quickApplyDescStart")}<span className="boldText"><Image className="boltWhiteIcon" src={QuickApplyBoltWhite} />{t("dashboard.jobEligibility.quickApply")}</span>{t("dashboard.jobEligibility.quickApplyDescEnd")}
                </div>
                <div className="quickApplyDescText hideText">
                  {t("dashboard.jobEligibility.quickApplyDescStart2")}<span className="boldText">{t("dashboard.jobEligibility.quickApply")}</span> {t("dashboard.jobEligibility.quickApplyDescEnd2")}
                </div>
                <div className="quickApplyDescText hideBottomText">
                  {t("dashboard.jobEligibility.quickApplyMobileText")}
                </div>
              </Row>
            </Container>
          </Col>
          <Col lg={9} className="d-flex align-items-start d-block d-xs-none p-0">
            <Container>
              <Row>
                {!isMobile && (
                  !isInitApiLoading && !isJobSearchWithViewsLoading ? (

                    quickApplyAdvJobs && quickApplyAdvJobs?.length > 0 && quickApplyAdvJobs?.map((item, index) => (
                      <div key={item?.id} style={{ marginTop: index > 1 ? 20 : 0, marginLeft: index % 2 === 0 ? 0 : 20 }}>
                        <JobCardContainer
                          job={item}
                          isQuickApplyAdvCard
                          sourceType={HOMEPAGE}
                          campaignCode={QUICK_APPLY_ELIGIBLE}
                          jobsSource={RecommendedJobsSourceTypes.NONE}
                        />
                      </div>
                    )
                    )
                  ) : (
                    <JobViewsSkeleton height={180} shouldWrap width={425} isEligibilityCard />
                  )
                )}
                {isMobile && (
                  !isInitApiLoading && !isJobSearchWithViewsLoading ? (
                    quickApplyAdvJobs && quickApplyAdvJobs?.length > 0 && <Container className="quickApplyCarouselContainer" fluid>
                      <JobsCarousel card={quickApplyAdvCarouselItems} isQuickApplyAdvCard />
                    </Container>
                  ) : (
                    <JobViewsSkeleton height={170} shouldWrap width={330} isEligibilityCard />
                  )
                )}
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
    </Container>) : null
  );
};

JobEligibilityDashboardAdvertisement.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  quickApplyAdvJobs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ).isRequired,
  quickApplyAdvCarouselItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  isJobSearchWithViewsLoading: PropTypes.bool.isRequired,
  isInitApiLoading: PropTypes.bool.isRequired,
};


export default connect()(withTranslation()(JobEligibilityDashboardAdvertisement));
